export enum InventoryDepth {
  FullStock = 'FULL_STOCK',
  LowStock = 'LOW_STOCK',
  OutOfStock = 'OUT_OF_STOCK',
  Oversold = 'OVERSOLD',
}
